import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Fleet from "@/pages/Fleet";
import CarDetail from "@/pages/CarDetail";
import Booking from "@/pages/Booking";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getVisitorId() {
  let id = localStorage.getItem("apf_visitor_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random();
    localStorage.setItem("apf_visitor_id", id);
  }
  return id;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function TrackVisits() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    axios.post(`${API}/track`, {
      path: pathname,
      referrer: document.referrer || "",
      visitor_id: getVisitorId(),
    }).catch(() => {});
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="min-h-screen">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <div className="grain" />
      <BrowserRouter>
        <ScrollToTop />
        <TrackVisits />
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/fleet" element={<PublicLayout><Fleet /></PublicLayout>} />
          <Route path="/fleet/:slug" element={<PublicLayout><CarDetail /></PublicLayout>} />
          <Route path="/book/:slug" element={<PublicLayout><Booking /></PublicLayout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster position="top-center" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
